export default "__VITE_ASSET__BUg$SUu3__";